import React, { useContext, useEffect, useRef, useState } from 'react';

//theme
import "primereact/resources/themes/lara-light-indigo/theme.css";
import Swal from 'sweetalert2';
import { AdditionalInfo } from '../components/AdditionalInfo';
import ChildrenData from '../components/ChildrenData';
import CommonAdvantages from '../components/CommonAdvantages';
import ParentData from '../components/ParentData';
import Wishes from '../components/Wishes';
import { AddressContext } from '../contexts/AddressContext';
import { ParameterContext } from '../contexts/ParameterContext';
import { RegisterContext } from '../contexts/RegisterContext';
import { EgnValid } from '../utils/EgnValidator';
import { ManualAddressRegisterBodyFormat, StringToDate, StringyyyyMMddToDate, FormatDateyyyyMMdd } from '../utils/RegisterApplicationBodyFormatter';
import { canShowSchoolsManualAddress, validateTwin, validateDublicateChildrenNames, validateLnchYearsFromSelectedDate, validateWishes } from '../utils/Validations';
import { WishValidatorContext } from '../contexts/WishValidatorContext';
import bcrypt from "bcryptjs-react";
import * as fileService from '../admin/services/fileService'
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { Declaration } from "../components/declaration";
import { editManualApplication, getApplication } from "../admin/services/applicationService";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from '../contexts/AuthContext';
import { SedGroupsCodes } from "../Shared/statuses";
export function EditManualAddressApplication() {
    const cyrillicRegex = /^(?!\s)(?:[\u0400-\u04FF-]|\s(?!\s))*[\u0400-\u04FF-] ?$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneRegex = /^\d+$/;
    const handleEmailRegex = /[a-zA-Z0-9._%+-@]/

    const parentDataRef = useRef(null);
    const childrenDataRef = useRef(null);
    const commonAdvantagesRef = useRef(null);
    const wishesRef = useRef(null);

    const [isEditSuccessfully, setIsEditSuccessfully] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const { regId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const { searchAdvantageSchools,
        validateSibling,
        dontHaveCompletedGroup,
        getResidences,
        validateAddressResidence,
        addressResidence,
        isChildHavePreparatoryGroup,
        cleanChildHavePreparatoryGroupState,
        siblingIsValid,
        getStreetByCode,
        residences,
        cleanSiblingErrors,
        validateSiblingLnch,
        getAddressById,
        currentAddressForManualEdit,
        permanentAddressForManualEdit,
        permanentStreetForManualEdit,
        currentStreetForManualEdit,
        twinsResidenceValidation,
        getStreetById
    } = useContext(AddressContext);

    const { validateSiblingEGN, removeError } = useContext(WishValidatorContext);
    const { isFormValid, toggleFormToValid, toggleFormToInvalid, commonAdvantages, advantages, schools, sedentaryGroups } = useContext(RegisterContext);
    const { user } = useContext(AuthContext)
    const [regNumData, setRegNumData] = useState(null);
    const { parameters } = useContext(ParameterContext);

    let stop_reg_dir;
    let autoTimeLived;
    let priemYear;
    let dirDisChildData;
    let maxDesires;

    if (parameters && parameters.nomParameters) {
        const parameterStopRegDir = parameters.nomParameters.find(x => x.param_name == 'STOP_REG_DIR');
        const parameterPriemYear = parameters.nomParameters.find(x => x.param_name == 'PRIEM_YEAR');
        const autoTimeLivedParam = parameters.nomParameters.find(x => x.param_name == 'AUTOMATIC_TIME_LIVED');
        const dirDisableChildData = parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');
        const maxDesiresParam = parameters.nomParameters.find(x => x.param_name == 'DESIRE_MAX');

        maxDesires = maxDesiresParam ? maxDesiresParam.value : 10;
        autoTimeLived = autoTimeLivedParam ? autoTimeLivedParam.value : 0;
        stop_reg_dir = parameterStopRegDir ? parameterStopRegDir.value : 0;
        dirDisChildData = dirDisableChildData ? dirDisableChildData.value : 0;
        priemYear = parameterPriemYear ? parameterPriemYear.value : new Date().getFullYear()
    } else {
        stop_reg_dir = 0;
        autoTimeLived = 0;
        priemYear = new Date().getFullYear();
    }

    const [isAddressesReady, setIsAddressesReady] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState({
        isCurrentAddress: false,
        isPermanentAddress: false
    });

    const [formData, setFormData] = useState({
        declarationAcc: null,
        twins: [],
        wishes: [],
        schools
    })

    document.title = `Редакция на заявление`;

    useEffect(() => {
        setTimeout(() => {
            getResidences();
        }, 500)
    }, [])

    useEffect(() => {
        if (regNumData) {
            setTimeout(() => {
                setLoading(true)
                if (regNumData.child.iS_LNC_C) {
                    searchAdvantageSchools(null, regNumData.regNumber.addresS_ID_C);
                } else {
                    searchAdvantageSchools(regNumData.regNumber.addresS_ID_P, regNumData.regNumber.addresS_ID_C);
                }

                if (user.role == 'Director' && dirDisChildData == 1) {
                    if (regNumData) {
                        setTimeout(() => {
                            setLoading(true)
                            validateAddressResidence(regNumData.child.chilD_EGN, regNumData.child.chilD_NAME);
                            regNumData.twins.forEach((twin, i) => {
                                twinsResidenceValidation(twin.chilD_EGN, twin.chilD_NAME, i);
                            });

                            if (regNumData.child.iS_LNC_C) {
                                searchAdvantageSchools(null, regNumData.regNumber.addresS_ID_C);
                            } else {
                                searchAdvantageSchools(regNumData.regNumber.addresS_ID_P, regNumData.regNumber.addresS_ID_C);
                            }
                            setLoading(false)
                        }, 500)
                    }
                }
                setLoading(false)
            }, 500)
        }

    }, [regNumData])

    useEffect(() => {
        let formDataValues = Object.values(formData);

        console.log(formData)

        if (!isFormValid) {
            if (formDataValues.every(x => x !== null && x !== '')) {
                if (canShowSchoolsManualAddress(formData)
                    && validateWishes(formData)
                    && Object.values(dontHaveCompletedGroup).some(x => x == '')
                ) {
                    if (autoTimeLived == 0 && formData.wishes.every(x => x.sedGroup)) {
                        toggleFormToValid();
                        setErrors({});
                    } else if (autoTimeLived == 1) {
                        toggleFormToValid();
                        setErrors({});
                    }
                }
            }

        }

        if (formData.twins.length > 0 && Object.values(formData.twins).some(x => x.twinEgn == '' || x.twinName == '')) {
            toggleFormToInvalid();
        }

        handleErrorLnch();

        console.log('validaciqta ', isFormValid)
    }, [formData])

    useEffect(() => {
        //console.log(formData)
        debugger
        if (addressResidence.length > 0) {
            getResidences()

            getStreetByCode(addressResidence.find(x => x.currenT_ADDR == 2).codE_STREET, true)
            getStreetByCode(addressResidence.find(x => x.currenT_ADDR == 1).codE_STREET, false)

            getAddressById(addressResidence.find(x => x.currenT_ADDR == 2).addresS_ID, addressResidence.find(x => x.currenT_ADDR == 2).codE_NM, true)
            getAddressById(addressResidence.find(x => x.currenT_ADDR == 1).addresS_ID, addressResidence.find(x => x.currenT_ADDR == 1).codE_NM, false)

            setFormData(state => ({
                ...state,
                currentAddressDate: new Date(addressResidence.find(x => x.currenT_ADDR == 2).residence),
                permanentAddressDate: new Date(addressResidence.find(x => x.currenT_ADDR == 1).residence),
            }))

            setErrors(state => ({ 
                ...state,
                validAddressResidance: null
            }))
        }

    }, [addressResidence])


    useEffect(() => {
        
    }, [regNumData])

    //Зарежда улиците на постоянния и настоящия адрес
    useEffect(() => {
        if (permanentStreetForManualEdit.id && residences.length > 0) {
            setFormData(state => ({
                ...state,
                permanentAddress: permanentStreetForManualEdit,
                permanentChildCity: residences.find(x => x.codeNm == permanentStreetForManualEdit.residenceId)?.nameNm
            }))

            getAddressById(permanentStreetForManualEdit.id, permanentStreetForManualEdit.residenceId, false)
        }

        if (currentStreetForManualEdit.id && residences.length > 0) {
            setFormData(state => ({
                ...state,
                currentAddress: currentStreetForManualEdit,
                currentChildCity: residences.find(x => x.codeNm == currentStreetForManualEdit.residenceId)?.nameNm
            }))

            getAddressById(currentStreetForManualEdit.id, currentStreetForManualEdit.residenceId, true)
        }
    }, [permanentStreetForManualEdit, currentStreetForManualEdit, residences])

    //Зарежда номерата на улиците на постоянния и настоящия адрес
    useEffect(() => {
        if (permanentAddressForManualEdit.id) {
            setFormData(state => ({
                ...state,
                permanentAddressInfo: permanentAddressForManualEdit
            }))
        }

        if (currentAddressForManualEdit.id) {
            setFormData(state => ({
                ...state,
                currentAddressInfo: currentAddressForManualEdit
            }))
        }
    }, [permanentAddressForManualEdit, currentAddressForManualEdit])

    useEffect(() => {
        setLoading(true)
        getApplication(regId, user.userName)
            .then((data) => {
                setRegNumData(data);

                getStreetById(data.regNumber.addresS_ID_C, true);
                getStreetById(data.regNumber.addresS_ID_P, false);

                setFormData(state => ({
                    ...state,
                    regId: regId,
                    parentIsEgn: data.parent && data.parent.iS_LNC_P ? '0' : '1',
                    parentEgn: data.parent && data.parent.parenT_EGN,
                    parentName: data.parent && data.parent.parenT_NAME,
                    parentPhone: data.parent && data.parent.parenT_PHONE,
                    parentEmail: data.parent && data.parent.parenT_EMAIL,
                    childIsEgn: data.child && data.child.iS_LNC_C ? '0' : '1',
                    childEgn: data.child && data.child.chilD_EGN,
                    childLnchDate: data.child && StringToDate(data.child.datE_R),
                    //currentAddress: currentStreet,
                    //currentAddressInfo: currentAddrInfo,
                    currentAddressDate: StringToDate(data.regNumber.addresS_C_RESIDENCE_DATE),
                    //permanentAddress: permanentStreet,
                    //permanentAddressInfo: permanentAddrInfo,
                    permanentAddressDate: StringToDate(data.regNumber.addresS_P_RESIDENCE_DATE),
                    childName: data.child && data.child.chilD_NAME,
                    twins: data.twins ? data.twins.map((twin, index) => ({
                        twinNumber: index + 1,
                        twinIsEgn: EgnValid(twin.chilD_EGN) ? '1' : '0',
                        twinEgn: twin.chilD_EGN,
                        twinName: twin.chilD_NAME,
                        twinLncDate: StringToDate(twin.datE_R)
                    })) : [],
                    commonAdvantages: data.commonAdvatages && data.commonAdvatages.reduce((acc, x) => {
                        acc[x.code] = data.desires[0][x.code.toLowerCase()] ? true : false;
                        return acc;
                    }, {}),
                    wishes: data.desires && data.desires.map((desire, i) => {
                        let wish = {};
                        data.advatages.forEach(x => {
                            if (x.code == 'K100') {
                                wish['K100_EGN'] = desire['k100_EGN'] == null ? "" : desire['k100_EGN'];
                                wish['K100_NAME'] = desire['k100_NAME'] == null ? "" : desire['k100_NAME'];
                                wish['K100_IsEgn'] = (EgnValid(desire['k100_EGN']) || desire['k100_EGN'] == '' || desire['k100_EGN'] == null) ? '1' : '0';
                                if (wish.K100_IsEgn == 0) {
                                    wish['K100_LnchDate'] = StringyyyyMMddToDate(desire['k100_lnchDate'])
                                }
                            } else if (x.code == 'K200') {
                                wish['K200_EGN'] = desire['k200_EGN'] == null ? "" : desire['k200_EGN'];
                                wish['K200_NAME'] = desire['k200_NAME'] == null ? "" : desire['k200_NAME'];
                                wish['K200_IsEgn'] = (EgnValid(desire['k200_EGN']) || desire['k200_EGN'] == '' || desire['k100_EGN'] == null) ? '1' : '0';
                                if (wish.K200_IsEgn == 0) {
                                    wish['K200_LnchDate'] = StringyyyyMMddToDate(desire['k200_lnchDate'])
                                }
                            } else {
                                wish[x.code] = desire[x.code.toLowerCase()] ? true : false;
                            }

                        })
                        wish.id = i;
                        // wish.school = schools.find(x => x.id == desire.dZ_ID)
                        wish.school = state.schools.find(x => x.id == desire.dZ_ID)

                        if (autoTimeLived == 0) {
                            wish.sedGroup = sedentaryGroups.find(x => x.code == SedGroupsCodes[`${desire.grupA_RESIDENCE}`]);
                        } else if (dirDisChildData == 1 && addressResidence.length == 0 && user.role == 'Director') {
                            wish.sedGroup = sedentaryGroups.find(x => x.code == SedGroupsCodes[`${desire.grupA_RESIDENCE}`]);
                        } else if (dirDisChildData == 0  && user.role == 'Director') {
                            wish.sedGroup = sedentaryGroups.find(x => x.code == SedGroupsCodes[`${desire.grupA_RESIDENCE}`]);
                        }

                        return wish;
                    }),
                    declarationAcc: null
                }));
                //console.log(data)
                setLoading(false)
            })
    }, [schools, regId])


    const cleanSiblingInputFields = (e, i, advCode) => {
        setFormData(state => {
            let wishes = [...state.wishes];

            wishes[i][`${advCode}_EGN`] = '';
            wishes[i][`${advCode}_NAME`] = '';

            if (wishes[i][`${advCode}_LnchDate`]) {
                wishes[i][`${advCode}_LnchDate`] = null;
            }

            return { ...state, wishes };
        })
    }

    const handleErrorLnch = () => {
        if ((formData.childIsEgn == '0' && validateLnchYearsFromSelectedDate(formData.childLnchDate, priemYear)) || formData.childIsEgn == '1') {
            setErrors(state => ({
                ...state,
                childLnchDate: ''
            }))
        } else {

            setErrors(state => ({ ...state, childLnchDate: 'Възрастта на детето е извън възрастовата група за прием в 1 клас!' }))
            toggleFormToInvalid();
        }

        if (formData.twins.length > 0) {
            formData.twins.forEach(x => {
                if ((x.twinIsEgn == '0' && validateLnchYearsFromSelectedDate(x.twinLncDate, priemYear)) || x.twinIsEgn == '1') {
                    setErrors(state => ({
                        ...state,
                        [x.twinNumber]: ''
                    }))
                } else {
                    setErrors(state => ({ ...state, childLnchDate: 'Възрастта на детето е извън възрастовата група за прием в 1 клас!' }))
                    toggleFormToInvalid();
                }
            })
        }
    }

    const commonAdvatagesChangeHandler = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        setFormData((prevState) => {
            const commonAdvantages = { ...prevState.commonAdvantages };
            commonAdvantages[fieldName] = e.checked;

            return { ...prevState, commonAdvantages };
        });
    }

    const toggleDropDown = (isCurrentAddress) => {
        if (isCurrentAddress) {
            setIsDropdownOpen(state => ({ ...state, isCurrentAddress: !isDropdownOpen.isCurrentAddress }))
        } else {
            setIsDropdownOpen(state => ({ ...state, isPermanentAddress: !isDropdownOpen.isPermanentAddress }))
        }
    }


    const handleChange = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (i !== undefined && fieldName.includes('twin')) {
            setFormData((prevState) => {
                const twins = [...prevState.twins];

                if ((fieldName.includes('Name') && cyrillicRegex.test(fieldValue) || fieldValue == '')) {
                    twins[i][fieldName] = fieldValue.toUpperCase();
                } else if (fieldName.includes('IsEgn')) {
                    setErrors(state => ({ ...state, [`${i}twinEgn`]: '' }))
                    if (formData.parentIsEgn == 0) {
                        twins[i][fieldName] = "0";
                    } else {
                        twins[i][fieldName] = fieldValue;
                    }
                } else if (fieldName == 'twinLncDate') {
                    twins[i][fieldName] = fieldValue;
                } else if (!fieldName.includes('Name')) {
                    twins[i][fieldName] = fieldValue.trim();
                }

                return { ...prevState, twins };

            });
        } else if (fieldName.includes('Name') || fieldName.includes('NAME')) {
            if (cyrillicRegex.test(fieldValue) || fieldValue == '') {
                setFormData({
                    ...formData,
                    [fieldName]: fieldValue.toUpperCase(),
                });
            }
        }
        else if (fieldName.includes('IsEgn')) {
            fieldName == 'parentIsEgn' ? setErrors(state => ({ ...state, parentEgn: '' })) : setErrors(state => ({ ...state, childEgn: '' }))

            if (fieldName == 'parentIsEgn' && fieldValue == 0) {
                setFormData(state => ({
                    ...state,
                    parentIsEgn: "0",
                    childIsEgn: "0"
                }))
            } else if (fieldName == 'childIsEgn' && formData.parentIsEgn == 0) {
                setFormData(state => ({
                    ...state,
                    parentIsEgn: "0",
                    childIsEgn: "0"
                }))
            } else {
                setFormData(state => ({
                    ...state,
                    [fieldName]: fieldValue
                }))
            }
        } else if (fieldName === 'currentAddress') {
            debugger

            let newAddress = { id: fieldValue.id, name: fieldValue.name, residenceId: fieldValue.residenceId }

            setFormData(state => ({
                ...state,
                currentAddress: newAddress,
                currentAddressInfo: null,
                currentAddressDate: null,
            }))

            toggleFormToInvalid();
            toggleDropDown(true);
        } else if (fieldName === 'permanentAddress') {
            debugger
            let newAddress = { id: fieldValue.id, name: fieldValue.name, residenceId: fieldValue.residenceId }
            setFormData(state => ({
                ...state,
                permanentAddress: newAddress,
                permanentAddressInfo: null,
                permanentAddressDate: null,
            }))

            toggleFormToInvalid();
            toggleDropDown(false);
        } else if (fieldName == 'declarationAcc') {
            setFormData(state => ({ ...state, [fieldName]: e.checked }))
        } else if (fieldName == 'parentEmail') {
            if (handleEmailRegex.test(fieldValue) || fieldValue == '') {
                setFormData(state => ({ ...state, [fieldName]: fieldValue }))
            }

            return
        } else if (fieldName == 'parentPhone' || fieldName == 'parentEgn' || fieldName == 'childEgn') {
            if (phoneRegex.test(fieldValue) || fieldValue == '') {
                setFormData(state => ({ ...state, [fieldName]: fieldValue }))
            }

            return
        } else if (fieldName == 'childLnchDate' || fieldName == 'permanentAddressDate'
            || fieldName == 'currentAddressDate' || fieldName == 'currentAddressInfo'
            || fieldName == 'permanentAddressInfo') {
            debugger

            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue
            }))
        } else if (fieldName == 'permanentChildCity') {
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue,
                permanentAddressInfo: null,
                permanentAddressDate: null,
                permanentAddress: null,
            }))

            toggleFormToInvalid();

            return
        } else if (fieldName == 'currentChildCity') {
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue,
                currentAddressInfo: null,
                currentAddressDate: null,
                currentAddress: null
            }))

            toggleFormToInvalid();

            return
        } else {
            setFormData(state => ({
                ...state,
                [fieldName]: fieldValue.trim()
            }))
        }


        if (fieldName.includes('currentAddressInfo')) {
            setIsDropdownOpen(state => ({ ...state, isCurrentAddress: false }))
            setIsAddressesReady(state => !state)
        } else if (fieldName.includes('permanentAddressInfo')) {
            setIsDropdownOpen(state => ({ ...state, isPermanentAddress: false }))
            setIsAddressesReady(state => !state)
        }

    }

    const onBlurValidate = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (fieldName == 'parentEmail') {
            if (!emailRegex.test(fieldValue) && fieldValue != '') {
                setErrors(state => ({ ...state, [fieldName]: 'Въведете валиден имейл адрес !' }))
                toggleFormToInvalid();
            } else {
                setErrors(state => ({ ...state, [fieldName]: null }))
            }
        }

        if (user.role == 'Director') {
            if (fieldName == 'childEgn' && EgnValid(fieldValue) && formData.childName.length > 0) {
                validateAddressResidence(fieldValue, formData.childName);
            } else if (fieldName == 'childName' && formData.childName.length > 0 && EgnValid(formData.childEgn)) {
                validateAddressResidence(formData.childEgn, fieldValue);
            } else if (formData.childIsEgn == '0' && fieldName == 'childEgn' && formData.childName.length > 0) {
                validateAddressResidence(fieldValue, formData.childName);
            } else if (fieldName == 'childName' && formData.childName.length > 0 && formData.childIsEgn == '0') {
                validateAddressResidence(formData.childEgn, fieldValue);
            }
        }
    }

    const onBlurTwinHandler = (e, i) => {
        let fieldName = e.target.name;
        let fieldValue = e.target.value;

        let twinValidationError = validateTwin(formData, fieldValue, i);
        if (fieldName == 'twinEgn' && formData.twins[i].twinIsEgn == 1) {

            if (!EgnValid(fieldValue)) {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: 'Въведете валидно ЕГН !' }))
                toggleFormToInvalid();
                return
            } else if (twinValidationError) {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: twinValidationError }))
                toggleFormToInvalid();
                return
            } else {
                setErrors(state => ({ ...state, [`${i}${fieldName}`]: null }))
            }
        }

        let dublicatedNamesError = validateDublicateChildrenNames(formData)

        if (twinValidationError) {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: twinValidationError }))
            toggleFormToInvalid();
        } else if (fieldName == 'twinName' && dublicatedNamesError) {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: dublicatedNamesError }))
            toggleFormToInvalid();
            return
        } else {
            setErrors(state => ({ ...state, [`${i}${fieldName}`]: null }))
        }
    }

    const onBlurWishHandler = (e, i, advCode) => {
        if (e.target.name == `${advCode}_EGN`) {
            validateSiblingEGN(e, i, advCode, formData)
        }

        if (formData.wishes[i][`${advCode}_IsEgn`] == 0 && formData.wishes[i][`${advCode}_LnchDate`] && formData.wishes[i][`${advCode}_NAME`]) {
            validateSiblingLnch(FormatDateyyyyMMdd(formData.wishes[i][`${advCode}_LnchDate`]), formData.wishes[i][`${advCode}_NAME`], advCode, formData.wishes[i].school.id, i);
            return
        }

        if (formData.wishes[i][`${advCode}_EGN`] && formData.wishes[i][`${advCode}_NAME`]) {
            validateSibling(formData.wishes[i][`${advCode}_EGN`], formData.wishes[i][`${advCode}_NAME`], advCode, formData.wishes[i].school.id, i);
        }
    }

    const wishChangeHandler = (e, i, advCode) => {
        let fullFieldName = e.target.name;
        let [advName, prop] = e.target.name.split('_');
        let fieldValue = e.target.value;
        let isCheckbox = e.target.type == 'checkbox';

        setFormData((prevState) => {
            let wishes = [...prevState.wishes];

            if (advName == 'school') {
                let isAlreadySelected = false;

                formData.wishes.forEach(x => {
                    if (x.school.id == fieldValue.id) {
                        isAlreadySelected = true;
                        Swal.fire({
                            title: 'Внимание!',
                            text: 'Училището вече е избрано като желание.',
                            icon: 'error',
                            confirmButtonText: 'ОК'
                        })

                        return;
                    }
                })

                if (isAlreadySelected) {
                    wishes[i][e.target.name] = '';
                    return { ...prevState, wishes };
                }

                for (var key in wishes[i]) {
                    if (key.includes('IsEgn')) {
                        wishes[i][key] = '1';
                    } else if (key.includes('EGN')) {
                        wishes[i][key] = '';
                    } else if (key.includes('NAME')) {
                        wishes[i][key] = '';
                    } else if (key == 'K50') {
                        wishes[i][key] = false;
                        cleanChildHavePreparatoryGroupState(i)
                    }
                }
            }

            if (fullFieldName.includes('NAME') && cyrillicRegex.test(fieldValue) || fieldValue == '') {
                wishes[i][e.target.name] = fieldValue.toUpperCase();
            } else if (fullFieldName.includes('NAME') && !cyrillicRegex.test(fieldValue)) {
                return { ...prevState, wishes };
            } else if (fullFieldName.includes('IsEgn')) {
                removeError(e, i, advCode)
                cleanSiblingErrors(i, advCode)
                cleanSiblingInputFields(e, i, advCode)
                wishes[i][e.target.name] = fieldValue;
            } else if (fullFieldName.includes('_LnchDate')) {
                wishes[i][e.target.name] = fieldValue;
            } else if (fullFieldName.includes('EGN')) {
                if (phoneRegex.test(fieldValue) || fieldValue == '') {
                    wishes[i][e.target.name] = fieldValue.trim();
                }
            } else {
                wishes[i][e.target.name] = isCheckbox ? e.target.checked : fieldValue;
            }


            return { ...prevState, wishes };
        });

        if (isCheckbox && advName == 'K50' && e.target.checked == true) {
            isChildHavePreparatoryGroup(formData.childEgn, formData.childName, formData.wishes[i].school.id, i);
        } else if (isCheckbox && advName == 'K50' && e.target.checked == false) {
            cleanChildHavePreparatoryGroupState(i);
        }


    }

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        let body;
        if (user.role == 'Director') {
            if (dirDisChildData == 1 && addressResidence.length == 0) {
                body = ManualAddressRegisterBodyFormat(formData, 0);
            } else {
                body = ManualAddressRegisterBodyFormat(formData, autoTimeLived );
            }
        } else {
            body = ManualAddressRegisterBodyFormat(formData, autoTimeLived );
        }

        //let body = ManualAddressRegisterBodyFormat(formData);
        editManualApplication(regId, body)
            .then((data) => {
                if (data.status == 400) {
                    Swal.fire({
                        title: 'Внимание!',
                        text: data.message,
                        icon: 'error',
                        confirmButtonText: 'ОК'
                    })
                } else {
                    setIsEditSuccessfully(true);
                    //Swal.fire({ title: "Успешно обновяване!", text: "", icon: "success" });
                }
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                Swal.fire({
                    title: 'Внимание!',
                    text: err.message,
                    icon: 'error',
                    confirmButtonText: 'ОК'
                })
            })
    }

    const addTwin = (e) => {
        e.preventDefault();

        let newState = { ...formData }
        let twinNumber = newState.twins.length + 1;

        if (twinNumber > 3) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Не може да добавяте повече от три близнака',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            return
        }

        newState.twins.push({ twinNumber, twinIsEgn: '1', twinEgn: '', twinName: '' });

        toggleFormToInvalid();

        setFormData(newState);
    }

    const removeTwin = (e) => {
        e.preventDefault();

        let newState = { ...formData }

        newState.twins.pop();

        toggleFormToInvalid();

        setFormData(newState);
    }

    const addWish = (e) => {
        e.preventDefault();

        let newState = { ...formData }

        if (newState.wishes.length >= maxDesires) {
            Swal.fire({
                title: 'Внимание!',
                text: 'Достигнали сте максималния брой желания.',
                icon: 'warning',
                confirmButtonText: 'ОК'
            })

            return
        }

        const advantagesMap = advantages.reduce((acc, x) => {
            if (x.code === 'K100') {
                acc['K100_NAME'] = '';
                acc['K100_EGN'] = '';
                acc['K100_IsEgn'] = true;
            } else if (x.code === 'K200') {
                acc['K200_NAME'] = '';
                acc['K200_EGN'] = '';
                acc['K200_IsEgn'] = true;
            } else {
                acc[x.code] = false;
            }
            return acc;
        }, {});

        newState.wishes.push({ id: '', school: '', ...advantagesMap });

        toggleFormToInvalid();

        setFormData(newState);
    }

    const removeWish = (e, i) => {
        e.preventDefault();
        Swal.fire({
            title: "Внимание !",
            text: `Сигурни ли сте, че искате да изтриете това желание?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Не",
            confirmButtonText: "Да"
        }).then((result) => {
            if (result.isConfirmed) {
                let newState = { ...formData }

                newState.wishes.pop();

                toggleFormToInvalid();

                setFormData(newState);
            }
        });
    }

    const isTwinsInValid = () => {
        if (formData.twins.length == 0) {
            return false;
        } else if (formData.twins.length > 0 && formData.twins.some(x => x.twinEgn == '' && x.twinName == '')) {
            return true
        } else {
            return false
        }
    }

    const scrollToComponent = (ref) => {
        const scrollToRef = ref.current;
        if (scrollToRef) {
            const elementOffset = scrollToRef.getBoundingClientRect().top;
            const offset = elementOffset - 100;

            const duration = 500;

            const startingY = window.pageYOffset;
            const diff = offset;
            let start;

            window.requestAnimationFrame(function step(timestamp) {
                if (!start) start = timestamp;
                const time = timestamp - start;
                const percent = Math.min(time / duration, 1);

                window.scrollTo(0, startingY + diff * percent + 70);

                if (time < duration) {
                    window.requestAnimationFrame(step);
                }
            });
        }
    };

    const getApplicationPDF = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            let response = '';
            const saltRounds = 12;
            const hashedParentEgn = await bcrypt.hash(formData.parentEgn, saltRounds);
            let downloadUrl = await fileService.getApplicationPDF({ regId: regId, hashedParentEgn: hashedParentEgn })

            if (downloadUrl) {
                window.open(downloadUrl, '_blank');
            }

            setLoading(false);
        } catch (error) {
            console.error('Error fetching PDF:', error);
            Swal.fire({
                title: 'Внимание!',
                text: error.message,
                icon: 'error',
                confirmButtonText: 'ОК'
            })
        }
    }

    const handleBack = (e) => {
        e.preventDefault();
        const regIdPattern = /^\/parent\/edit\/\d+$/;
        const schadmRegIdPattern = /^\/schadm\/edit\/\d+$/;

        if (regIdPattern.test(location.pathname)) {
            navigate("/parent")
        } else if (schadmRegIdPattern.test(location.pathname)) {
            navigate("/schadm/editreg")
        }

    }

    return (
        <div className="d-flex container-mob gap-5">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            {regId && !isEditSuccessfully
                ? <>
                    <div className="form-navigator position-sticky" style={{ top: '50px' }}>
                        <button onClick={() => scrollToComponent(parentDataRef)}>Данни за родител</button>
                        <button onClick={() => scrollToComponent(childrenDataRef)}>Данни за дете</button>
                        <button onClick={() => scrollToComponent(commonAdvantagesRef)}>Предимства</button>
                        <button onClick={() => scrollToComponent(wishesRef)}>Желания</button>
                    </div>
                    <div className="w-80">
                        <div className="title_entr">Редакция на заявление {regId}</div>

                        <div className="reg_cont">

                            <form className="form w-100 d-flex flex-row justify-content-between align-items-center flex-wrap" action="parent_ack" method="post">
                                <ParentData
                                    ref={parentDataRef}
                                    id='parentData'
                                    formData={formData}
                                    handleChange={handleChange}
                                    onBlurValidate={onBlurValidate}
                                    errors={errors}
                                    isEdit={true}
                                />
                                <ChildrenData
                                    ref={childrenDataRef}
                                    id='childrenData'
                                    formData={formData}
                                    handleChange={handleChange}
                                    addTwin={addTwin}
                                    removeTwin={removeTwin}
                                    isDropdownOpen={isDropdownOpen}
                                    toggleDropDown={toggleDropDown}
                                    onBlurValidate={onBlurValidate}
                                    onBlurTwins={onBlurTwinHandler}
                                    errors={errors}
                                    isEdit={true}
                                />
                                <CommonAdvantages
                                    ref={commonAdvantagesRef}
                                    id='commonAdvantages'
                                    formData={formData}
                                    handleChange={commonAdvatagesChangeHandler}
                                />

                                <>
                                    < Wishes
                                        ref={wishesRef}
                                        id='wishes'
                                        formData={formData}
                                        handleChange={handleChange}
                                        wishChangeHandler={wishChangeHandler}
                                        addWish={addWish}
                                        removeWish={removeWish}
                                        isEdit={true}
                                        cleanSiblingInputFields={cleanSiblingInputFields}
                                        onBlurWishHandler={onBlurWishHandler}
                                    />
                                    <div className="children_data d-flex flex-wrap mb-2 mt-4">
                                        <Declaration formData={formData} handleChange={handleChange} />
                                    </div>
                                </>
                                <div className="d-flex gap-2 w-100 flex-wrap">
                                    <button
                                        className="btn but_add mb-3 mt-3 w-100-mob"
                                        disabled={!isFormValid || !formData.declarationAcc || Object.values(dontHaveCompletedGroup).some(x => x !== '') || Object.values(siblingIsValid).some(x => x.length > 0) || isTwinsInValid()}
                                        onClick={onSubmit}>
                                        Завърши редакцията
                                    </button>
                                    <button
                                        className="btn btn-prim-red mb-3 mt-3 text-light w-100-mob"
                                        onClick={handleBack}>
                                        Отказ
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </>
                : <>
                    <div className="children_data">
                        <div className="title_entr text-success">Редакцията на заявлението е успешна</div>
                        <div className="htext text-center">Вашият номер на редактираното заявление е <b>{regId}</b></div>
                        <p className="text-md-center">За да изтеглите вашето заявление <a href="/#" onClick={getApplicationPDF}>натиснете тук</a></p>
                    </div>
                </>
            }
        </div>
    );
}